import { observer } from 'mobx-react';

// Components
import { TODO } from 'utils/Types';
import { RadioToggle } from './styles';

interface RadioInputToggleProps {
  choices: Array<TODO>;
  className?: string;
  id?: string;
  initialValue?: string;
  label?: string;
  name?: string;
  required?: boolean;
}
/**
 * Radio input with the appearance of a toggle switch.
 */
const RadioInputToggle = ({ choices, className, id, initialValue, label, name, required }: RadioInputToggleProps) => (
  <RadioToggle
    button
    choices={choices}
    className={className}
    id={id}
    initialValue={initialValue}
    label={label}
    name={name}
    required={required}
  />
);

export default observer(RadioInputToggle);
